import CarScrollspyContainer from "../../../components/car/detail/CarScrollspy";

const CarScrollspy = () => {
  return <CarScrollspyContainer />;
};

export default CarScrollspy;
